import React, { useEffect } from 'react';
import { Container } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import '../Features.css';

const Vignette = () => {
  const { t } = useTranslation();
  useEffect(() => {
    document.getElementById('home').classList.add('featureContent');
    return () => {
      document.getElementById('home').classList.remove('featureContent');
    };
  });
  useEffect(() => {
    setTimeout(() => {
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }, 100);
  }, []);
  return (
    <Container className="featurePages texts">
      <div className="header">
        <div className="headerContent">
          <h2 className="title">{t('contents:vignetteTitle1')}</h2>
          <p className="text">{t('contents:vignetteParagraph1')}</p>
        </div>
        <img src={require('../../../assets/images/features/pages/vignette/vignette_01.png')} />
      </div>
      <div className="content">
        <div className="container">
          <div className="section section01">
            <div className="textBox">
              <h2 className="title">{t('contents:vignetteTitle2')}</h2>
              <p>{t('contents:vignetteParagraph2')}</p>
            </div>
            <div className="imageBox">
              <img
                src={require('../../../assets/images/features/pages/vignette/vignette_02.png')}
              />
            </div>
          </div>
          <div className="section section02">
            <div className="textBox">
              <h2 className="title">{t('contents:vignetteTitle3')}</h2>
              <p>{t('contents:vignetteParagraph3')}</p>
            </div>
            <div className="imageBox">
              <img
                src={require('../../../assets/images/features/pages/vignette/vignette_03.png')}
              />
            </div>
          </div>
          <div className="section section03">
            <div className="textBox">
              <h2 className="title">{t('contents:vignetteTitle4')}</h2>
              <p>{t('contents:vignetteParagraph4')}</p>
            </div>
            <div className="imageBox">
              <img
                src={require('../../../assets/images/features/pages/vignette/vignette_04.png')}
              />
            </div>
          </div>
          <div className="section section04">
            <div className="textBox">
              <h2 className="title">{t('contents:vignetteTitle5')}</h2>
              <p>{t('contents:vignetteParagraph5')}</p>
            </div>
            <div className="imageBox">
              <img
                src={require('../../../assets/images/features/pages/vignette/vignette_05.png')}
              />
            </div>
          </div>
          <div className="section section05">
            <div className="textBox">
              <h2 className="title">{t('contents:vignetteTitle6')}</h2>
              <p>
                {t('contents:vignetteParagraph6')}
                <br />
                {t('contents:vignetteParagraph7')}
              </p>
            </div>
            <div className="imageBox">
              <img
                src={require('../../../assets/images/features/pages/vignette/vignette_06.png')}
              />
            </div>
          </div>
        </div>
        <div className="footer"></div>
      </div>
    </Container>
  );
};

export default Vignette;
